import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "tags" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "border inline-flex items-center text-xs" }
const _hoisted_6 = { class: "py-1 pl-2" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "border inline-flex items-center text-xs" }
const _hoisted_10 = { class: "py-1 pl-2" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "border inline-flex items-center text-xs" }
const _hoisted_13 = { class: "py-1 pl-2" }
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = { class: "border inline-flex items-center text-xs" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sr-only" }
const _hoisted_18 = { class: "border inline-flex items-center text-xs" }
const _hoisted_19 = { class: "py-1 pl-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["space-y-5", { 'opacity-0': _ctx.loading }])
  }, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.totalCount) + " " + _toDisplayString(_ctx.t(_ctx.totalCount === 1 ? 'result' : 'results')) + " ", 1),
      (_ctx.basicFilter.fullText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.t('for')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.basicFilter.fullText), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_ctx.basicFilter.openContent)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('open_content')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "p-2",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearOpenContent && _ctx.clearOpenContent(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('clear')) + " " + _toDisplayString(_ctx.t('open_content')) + " " + _toDisplayString(_ctx.t('filter')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    width: "10",
                    height: "10",
                    viewBox: "0 0 10 10",
                    focusable: "false",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M1,1 L9,9 M1,9 L9,1",
                      stroke: "currentColor"
                    })
                  ], -1))
                ])
              ])
            ]),
            _cache[4] || (_cache[4] = _createTextVNode("   ", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.basicFilter.hasAudioVideo)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('has_audio_video')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "p-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearHasAudioVideo && _ctx.clearHasAudioVideo(...args)))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    width: "10",
                    height: "10",
                    viewBox: "0 0 10 10",
                    focusable: "false",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M1,1 L9,9 M1,9 L9,1",
                      stroke: "currentColor"
                    })
                  ], -1)
                ]))])
              ])
            ]),
            _cache[6] || (_cache[6] = _createTextVNode("   ", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.dateRange)
        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.dateRange), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "p-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearDate && _ctx.clearDate(...args)))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('clear')) + " " + _toDisplayString(_ctx.t('date')) + " " + _toDisplayString(_ctx.t('filter')), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("svg", {
                    width: "10",
                    height: "10",
                    viewBox: "0 0 10 10",
                    focusable: "false",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M1,1 L9,9 M1,9 L9,1",
                      stroke: "currentColor"
                    })
                  ], -1))
                ])
              ])
            ]),
            _cache[8] || (_cache[8] = _createTextVNode("   ", -1))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorFilter, (color) => {
        return (_openBlock(), _createElementBlock("li", { key: color }, [
          _createElementVNode("span", null, [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("span", {
                class: "color",
                style: _normalizeStyle(`background-color: ${color}`)
              }, null, 4),
              _createElementVNode("button", {
                type: "button",
                class: "p-2",
                onClick: ($event: any) => (_ctx.clearColor(color))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('clear')) + " " + _toDisplayString(_ctx.t('color')) + " " + _toDisplayString(color) + " " + _toDisplayString(_ctx.t('filter')), 1),
                _cache[9] || (_cache[9] = _createElementVNode("svg", {
                  width: "10",
                  height: "10",
                  viewBox: "0 0 10 10",
                  focusable: "false",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", {
                    d: "M1,1 L9,9 M1,9 L9,1",
                    stroke: "currentColor"
                  })
                ], -1))
              ], 8, _hoisted_16)
            ])
          ]),
          _cache[10] || (_cache[10] = _createTextVNode("   ", -1))
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedFilter, ([key, value]) => {
        return (_openBlock(), _createElementBlock("li", { key: key }, [
          _createElementVNode("span", null, [
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(value.text), 1),
              _createElementVNode("button", {
                type: "button",
                class: "p-2",
                onClick: ($event: any) => (_ctx.clearFilter(key))
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('clear')) + " " + _toDisplayString(value.text) + " " + _toDisplayString(_ctx.t('filter')), 1),
                _cache[11] || (_cache[11] = _createElementVNode("svg", {
                  width: "10",
                  height: "10",
                  viewBox: "0 0 10 10",
                  focusable: "false",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", {
                    d: "M1,1 L9,9 M1,9 L9,1",
                    stroke: "currentColor"
                  })
                ], -1))
              ], 8, _hoisted_20)
            ])
          ]),
          _cache[12] || (_cache[12] = _createTextVNode("   ", -1))
        ]))
      }), 128))
    ])
  ], 2))
}